var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9657 16.2735C14.7179 16.2735 16.1384 14.8372 16.1384 13.0655C16.1384 11.2937 14.7179 9.85742 12.9657 9.85742C11.2134 9.85742 9.79297 11.2937 9.79297 13.0655C9.79297 14.8372 11.2134 16.2735 12.9657 16.2735Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4973 17.6493L15.2227 15.3486",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38672 4.18994H15.3974",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48763 2.59619C3.39091 2.59619 3.3125 2.67547 3.3125 2.77327C3.3125 2.87108 3.39091 2.95036 3.48763 2.95036C3.58436 2.95036 3.66277 2.87108 3.66277 2.77327C3.66277 2.67547 3.58436 2.59619 3.48763 2.59619",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88998 2.59619C4.79325 2.59619 4.71484 2.67547 4.71484 2.77327C4.71484 2.87108 4.79325 2.95036 4.88998 2.95036C4.9867 2.95036 5.06511 2.87108 5.06511 2.77327C5.06511 2.67547 4.9867 2.59619 4.88998 2.59619",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29232 2.59619C6.1956 2.59619 6.11719 2.67547 6.11719 2.77327C6.11719 2.87108 6.1956 2.95036 6.29232 2.95036C6.38904 2.95036 6.46745 2.87108 6.46745 2.77327C6.46745 2.67547 6.38904 2.59619 6.29232 2.59619",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.991 12.6873H2.78779C2.014 12.6873 1.38672 12.0531 1.38672 11.2707V2.77067C1.38672 1.98827 2.014 1.354 2.78779 1.354H13.9964C14.7701 1.354 15.3974 1.98827 15.3974 2.77067V7.02067",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/search-bar.3a06e638a7efa5a43b50c5e0267d258b.svg";
export { ForwardRef as ReactComponent };